import { render, staticRenderFns } from "./smallWeChatManageList.vue?vue&type=template&id=bde6fa12&scoped=true"
import script from "./smallWeChatManageList.vue?vue&type=script&lang=js"
export * from "./smallWeChatManageList.vue?vue&type=script&lang=js"
import style0 from "./smallWeChatManageList.vue?vue&type=style&index=0&id=bde6fa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde6fa12",
  null
  
)

export default component.exports